import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { Get_TargetFunnel, Get_LeadIndicatorFunnel } from "../../../services/userAPI";
import "../../Dashboard/Darts/masterConfiguration/productConfiguration/productConfiguration.css";

import Funnel1 from "../../../Images/funnel1.png";
import Funnel2 from "../../../Images/funnel2.png";
import Funnel3 from "../../../Images/funnel3.png";
import Funnel4 from "../../../Images/funnel4.png";
import Funnel5 from "../../../Images/funnel5.png";
import Funnel6 from "../../../Images/funnel6.png";
import Funnel7 from "../../../Images/funnel7.png";
import Funnel8 from "../../../Images/funnel8.png";
import Funnel9 from "../../../Images/funnel9.png";
import Funnel10 from "../../../Images/funnel10.png";
import Funnel11 from "../../../Images/funnel11.png";
import Funnel12 from "../../../Images/funnel12.png";
import Funnel13 from "../../../Images/funnel13.png";
import Funnel14 from "../../../Images/funnel14.png";
import Funnel15 from "../../../Images/funnel15.png";
import Funnel16 from "../../../Images/funnel16.png";
import Funnel17 from "../../../Images/funnel17.png";
import Funnel18 from "../../../Images/funnel18.png";
import Funnel19 from "../../../Images/funnel19.png";
import Funnel20 from "../../../Images/funnel20.png";

import Redline from "../../../Images/red-line1.png"
import { useNavigate, useLocation } from "react-router-dom";
import { Tooltip } from 'antd';
import PageBreadcrumb from '../../../reusableField/PageBreadcrumb';

const funnelImages = [
    Funnel1, Funnel2, Funnel3, Funnel4, Funnel5, Funnel6, Funnel7, Funnel8, Funnel9, Funnel10,
    Funnel11, Funnel12, Funnel13, Funnel14, Funnel15, Funnel16, Funnel17, Funnel18, Funnel19, Funnel20
];

const AdminTargetFunnelPreview = ({ onBack, onNext, targetData, roleId, accountId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const accountName = location.state?.accountName;
    const name = location.state?.name;
    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const dartsNeeded = location.state?.dartsNeeded;

    // Fetch data from API
    const { data, loading, error } = useQuery(Get_TargetFunnel, {
        variables: { roleId: roleId },
        skip: !roleId,
    });

    if (error) console.error("❌ GraphQL API Error:", error);

    const [stages, setStages] = useState([]);
    const [leadStages, setLeadStages] = useState([]);

    // Fetch lead indicator data from API
    const { data: leadData, loading: leadLoading, error: leadError } = useQuery(Get_LeadIndicatorFunnel, {
        variables: { roleId: roleId },
        skip: !roleId,
    });

    if (leadError) console.error("❌ Lead Indicator API Error:", leadError);

    // Update stages when API data is available
    useEffect(() => {
        if (data?.getKpisForRole && data.getKpisForRole.length > 0) {
            const reversedData = [...data.getKpisForRole].reverse(); // Reverse only the data
            const updatedStages = reversedData.map((item, index) => ({
                id: item.id,
                name: item.name,
                target: item.defaultValue,
                funnel: index < 7 ? funnelImages[index] : funnelImages[6],
            }));
            setStages(updatedStages);
        } else if (targetData?.targets && targetData.targets.length > 0) {
            const reversedData = [...targetData.targets].reverse(); // Reverse only the data
            const updatedStages = reversedData.map((item, index) => ({
                id: item.id,
                name: item.name,
                target: item.monthly,
                funnel: index < 7 ? funnelImages[index] : funnelImages[6],
            }));
            setStages(updatedStages);
        }
    }, [data, targetData]);

    // Update lead indicator stages when API data is available
    useEffect(() => {
        if (leadData?.getKiisForRole && leadData.getKiisForRole.length > 0) {
            const reversedData = [...leadData.getKiisForRole].reverse();
            const updatedStages = reversedData.map((item, index) => ({
                id: item.id,
                name: item.name,
                dailyTarget: item.dailyTarget,
                monthlyTarget: item.defaultValue,
                funnel: index < 7 ? funnelImages[index] : funnelImages[6],
            }));
            setLeadStages(updatedStages);
        }
    }, [leadData]);


    // Handle input change
    const handleInputChange = (index, key, value) => {
        const updatedStages = [...stages];
        updatedStages[index][key] = value;
        setStages(updatedStages);
    };

    const handleLeadInputChange = (index, key, value) => {
        const updatedStages = [...leadStages];
        updatedStages[index][key] = value;
        setLeadStages(updatedStages);
    };

    // Loading and error handling
    if (loading) return <p>Loading...</p>;

    const handleProceed = () => {
        // If onNext prop exists, use it; otherwise fall back to navigate
        if (onNext) {
            onNext({ roleId, targetFunnelName: data?.getTargetFunnel?.name });
        } else {
            // Keep the existing navigate as fallback
            navigate("/lead-indicator-selection", {
                state: { roleId, targetFunnelName: data?.getTargetFunnel?.name },
            });
        }
    };

    return (
        <div className="target-funnel-preview">
            <h2 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>Target Funnel Preview</h2>
            <div className="funnel-container">

                <div className="funnel-header">
                    <div className="funnel-stage-header"></div>
                    <div className="red-line-header"></div>
                    <div className="input-header-container">
                        <div className="input-header">Stages</div>
                        <div className="input-header">Targets <br />(Monthly)</div>
                    </div>
                </div>

                {stages.length > 0 ? (
                    stages.map((stage, index) => (
                        <div key={index} className="funnel-row">
                            {/* Funnel Image */}
                            <div className="funnel-stage">
                                <img src={stage.funnel} alt={`Funnel stage ${index + 1}`} className="funnel-image" />
                            </div>

                            <div className="red-line-container">
                                <img src={Redline} alt="Red line separator" className="red-line" />
                            </div>

                            {/* Input Fields */}
                            <div className="input-container">
                                <Tooltip title={stage.name}>
                                    <input
                                        type="text"
                                        className="stage-input"
                                        value={stage.name}
                                        readOnly
                                    />
                                </Tooltip>
                                <input
                                    type="number"
                                    className="stage-inputs"
                                    value={stage.target}
                                    onChange={(e) => handleInputChange(index, "target", e.target.value)}
                                    readOnly
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No funnel data available.</p>
                )}
            </div>

            <h2 style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "40px" }}>Lead Indicator Preview</h2>
            <div className="funnel-container">

                <div className="grid items-end" style={{ gridTemplateColumns: "250px 60px 1fr", marginBottom: "-46px" }}>
                    <div></div>
                    <div></div>
                    <div className="flex items-end gap-[10px] pt-[10px]">
                        <div className="flex-1 text-center font-medium">Stages</div>
                        <div className="w-[50%] text-center font-medium">Daily<br />Norm</div>
                        <div className="w-[30%] text-center font-medium">Targets<br />(Monthly)</div>
                    </div>
                </div>

                {leadStages.length > 0 ? (
                    leadStages.map((stage, index) => (
                        <div key={index} className="funnel-row">
                            <div className="funnel-stage">
                                <img src={stage.funnel} alt={`Funnel stage ${index + 1}`} className="funnel-image" />
                            </div>

                            <div className="red-line-container">
                                <img src={Redline} alt="Red line separator" className="red-line" />
                            </div>

                            <div className="input-container">
                                <Tooltip title={stage.name}>
                                    <input
                                        type="text"
                                        className="stage-input"
                                        value={stage.name}
                                        readOnly
                                    />
                                </Tooltip>
                                <input
                                    type="number"
                                    className="stage-inputs"
                                    value={stage.dailyTarget}
                                    onChange={(e) => handleLeadInputChange(index, "dailyTarget", e.target.value)}
                                    readOnly
                                />
                                <input
                                    type="number"
                                    className="stage-inputs"
                                    value={stage.monthlyTarget}
                                    onChange={(e) => handleLeadInputChange(index, "monthlyTarget", e.target.value)}
                                    readOnly
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No lead indicator data available.</p>
                )}
            </div>

            <div className="funnel-actions">
                <button className="back-btn-target-funnel" onClick={onBack}>Back</button>
                <button className="proceed-btn" onClick={handleProceed}>Proceed</button>
            </div>
        </div>
    );
};

export default AdminTargetFunnelPreview;